export const VIDEO = "video";
export const FILE = "file";
export const IMAGE = "image";
